module.exports = __webpack_public_path__ + "img/points-menu.221ef3f3.svg";